import axios from 'axios'
import authHeader from './auth-header'
import { AUTH_API_URL } from '@/config/auth-config'

class AuthService {
  login(user) {
    return axios
      .post(AUTH_API_URL + 'auth/login', {
        username: user.username,
        password: user.password,
      })
      .then((response) => {
        if (response.data.token) {
          localStorage.setItem('user', JSON.stringify(response.data))
        }
        return response.data
      })
  }

  logout() {
    localStorage.removeItem('user')
    localStorage.removeItem('onlyShowAvailableStreams')
    localStorage.removeItem('currentfleet')
  }

  register(user) {
    return axios.post(AUTH_API_URL + 'auth/register', {
      username: user.username,
      password: user.password,
    })
  }

  editProfile(user) {
    const id = JSON.parse(localStorage.getItem('user')).id

    return axios.put(
      AUTH_API_URL + 'auth',
      {
        id,
        username: user.username,
        oldpassword: user.oldPassword,
        newpassword: user.newPassword,
      },
      { headers: authHeader() },
    )
  }

  changePassword(oldPassword, newPassword) {
    return axios.put(
      AUTH_API_URL + 'auth/password',
      {
        oldPassword,
        newPassword,
      },
      { headers: authHeader() },
    )
  }

  setTimezone(timezone) {
    return axios.put(
      AUTH_API_URL + 'auth/timezone',
      { timezone },
      { headers: authHeader() },
    )
  }
}

export default new AuthService()
